import React from "react";
import { Alert } from "antd";
import { useQuery } from "@apollo/client";
import { GQL_OSSERVATORIO_TARI_TARIFFE } from "../../../apollo/query/osservatorio-tari";

/**
 * Avviso se le tariffe dell'anno sono state adottate o caricate oltre il termine (valida = false),
 * con il testo della nota MEF. Non mostra nulla se le tariffe sono valide o non disponibili.
 */
const MEFTariffeValidita = ({ comuneCode, anno }) => {
   const { data } = useQuery(GQL_OSSERVATORIO_TARI_TARIFFE, {
      variables: { comune_code_istat: comuneCode, anno },
   });

   const categorie = data?.osservatorioTariTariffe?.categorie ?? [];
   const nonValide = categorie.filter((c) => c.valida === false);

   if (!nonValide.length) {
      return null;
   }

   //di norma la nota è la stessa per tutte le categorie
   const note = [...new Set(nonValide.map((c) => c.nota_mef).filter(Boolean))];

   return (
      <Alert
         type="warning"
         showIcon
         style={{ marginBottom: 12 }}
         message={
            nonValide.length === categorie.length
               ? "Tariffe adottate o caricate oltre il termine"
               : `Tariffe adottate o caricate oltre il termine per ${
                    nonValide.length
                 } categorie su ${categorie.length}: ${nonValide
                    .map((c) => c.codice)
                    .join(", ")}`
         }
         description={
            note.length > 0 && (
               <div style={{ whiteSpace: "pre-line" }}>{note.join("\n\n")}</div>
            )
         }
      />
   );
};

export default MEFTariffeValidita;
